import { action, computed, observable, makeAutoObservable } from 'mobx';
import {
    TopEventsEventsState,
    EventCombinedType,
    CompetitionCombinedType,
} from 'src/AppState/CmsState/TopEventsState/TopEventsState';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { TrpcClient } from 'src/AppState/TrpcClient';

export class TopEventsEventState {
    @observable public isActive: boolean = this.eventData.is_active;
    @observable public showDeletePopup: boolean = false;

    public constructor(
        private readonly trpcClient: TrpcClient,
        private readonly sdkStaff: SdkStaff,
        private readonly eventData: EventCombinedType,
        private readonly getCompetitionData: (competitionId: number) => CompetitionCombinedType | null,
        private readonly handleDeleteCompetition: (sportSlug: string) => Promise<void>,
        private readonly topEventsEventsSectionState: TopEventsEventsState
    ) {
        makeAutoObservable(this);
    }

    @computed public get eventName(): string {
        return this.sdkStaff.models.getEvent(this.eventData.event_id)?.name ?? '';
    }

    @computed public get isEventFinished(): boolean | null {
        return this.sdkStaff.models.getEvent(this.eventData.event_id)?.timeMatchStartedAndFinished ?? null;
    }

    @action public setEventActive = async (): Promise<void> => {
        const topEventsCompetitionDetailsData = {
            ...this.eventData,
            is_active: !this.eventData.is_active,
        };

        this.isActive = !this.isActive;

        try {
            await this.trpcClient.client.topEventsEvents.updateTopEventsEvent.mutate({
                id: this.eventData.id,
                data: topEventsCompetitionDetailsData,
            });

            await this.topEventsEventsSectionState.topEventsEventsResource.refresh();
        } catch (error) {
            console.error(error);
        }
    };

    @action public handleHideDeletePopup = (): void => {
        this.showDeletePopup = false;
    };

    @action public handleShowDeletePopup = (): void => {
        this.showDeletePopup = true;
    };

    @action public handleDeleteEvent = async (): Promise<void> => {
        this.topEventsEventsSectionState.setIsLoading(true);
        const competitionId = this.eventData.competition_id;
        const removeResult = await this.trpcClient.client.topEventsEvents.deleteTopEventsEvent.mutate({
            id: this.eventData.id,
        });

        if (removeResult.status === 200) {
            await this.topEventsEventsSectionState.topEventsEventsResource.refresh();
            this.topEventsEventsSectionState.setSportsDataFromResource();

            const eventsList = this.getCompetitionData(competitionId)?.events_list;

            if (eventsList?.length === 0) {
                await this.handleDeleteCompetition(this.eventData.sport_id);
            }
        } else {
            console.error("The item couldn't be deleted.");
        }
        this.topEventsEventsSectionState.setIsLoading(false);
    };
}
